import { useTheme } from '../hooks/useTheme';

function Maintenance() {
  useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-base">
      <div className="max-w-md w-full text-center p-6 bg-surface-secondary rounded-lg border border-border-primary">
        <h1 className="text-2xl font-semibold text-text-primary mb-2">Estamos en mantenimiento</h1>
        <p className="text-text-secondary mb-4">
          Volveremos en unos minutos. Gracias por tu paciencia.
        </p>
      </div>
    </div>
  );
}

export default Maintenance;
